<mat-menu #menu="matMenu">
    <button mat-menu-item *ngFor="let language of trans.languages" (click)="selectLanguage(language.id)">
        <mat-icon>{{ language.id === currentLanguage ? 'check' : '' }}</mat-icon>
        <span [class.current-language]="language.id === currentLanguage">{{ language.name }}</span>
    </button>
</mat-menu>
